// Iman Ink — Product page JavaScript

// Gallery
const thumbs = document.querySelectorAll('.product-gallery-thumb');
const mainImg = document.querySelector('.product-gallery-main img');
if (thumbs.length && mainImg) {
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const src = thumb.querySelector('img')?.src;
      if (src) mainImg.src = src;
    });
  });
}

// Variant picker
document.querySelectorAll('.variant-option input[type="radio"]').forEach(radio => {
  radio.addEventListener('change', () => {
    const form = radio.closest('form');
    if (!form) return;
    const radios = form.querySelectorAll('.variant-option input[type="radio"]:checked');
    const values = Array.from(radios).map(r => r.value);
    const variantData = JSON.parse(form.dataset.variants || '[]');
    const match = variantData.find(v => {
      const opts = [v.option1, v.option2, v.option3].filter(Boolean);
      return JSON.stringify(opts) === JSON.stringify(values);
    });
    if (match) {
      const idInput = form.querySelector('[name="id"]');
      if (idInput) idInput.value = match.id;
      const priceEl = document.querySelector('.product-price');
      if (priceEl && match.price) {
        priceEl.innerHTML = `$${(match.price / 100).toFixed(2)}`;
      }
    }
  });
});
